import { Heading } from "components/Theme/heading";
import { useSelectedScheme } from "hooks/useScheme";
import type React from "react";

const RequireScheme = (props: {
  children: React.ReactNode;
}): React.ReactElement => {
  return (
    <>
      {useSelectedScheme() ? (
        props.children
      ) : (
        <Heading>Please select a scheme.</Heading>
      )}
    </>
  );
};

export default RequireScheme;
